import { Container } from 'reactstrap';
import s from 'styled-components';

export const ServicesAndSidebarContainer = s(Container)`
  margin-top: 50px;
  margin-bottom: 40px;
`;
